export enum ModelEventType {
  EMBEDDED_LIST_PAGE_ADDED = 'EMBEDDED_LIST_PAGE_ADDED',
  EMBEDDED_LIST_PAGE_REMOVED = 'EMBEDDED_LIST_PAGE_REMOVED',
  LIST_PAGE_NAVIGATION_PROPS_UPDATED = 'LIST_PAGE_NAVIGATION_PROPS_UPDATED',
  NAVIGATE_TO_DETAIL_PAGE_ADDED = 'NAVIGATE_TO_DETAIL_PAGE_ADDED',
  NAVIGATE_TO_DETAIL_PAGE_REMOVED = 'NAVIGATE_TO_DETAIL_PAGE_REMOVED'
}

export interface ModalEvent {
  modelId: string;
  event: ModelEventType;
  oldValue?: string;
  newValue?: string;
}
